export const mutations = {
  SET_BRANDINGS(state, brandings) {
    state.brandings = brandings
  },
}
